import type { TimelineEntry } from '../../contracts/stream/types';

/**
 * Strips placeholder reasoning entries and force-completes any thinking items
 * still in an active state. Used on stream completion and error paths.
 */
export const finalizeTimeline = (timeline: TimelineEntry[]): TimelineEntry[] =>
  timeline
    .filter((entry) => !(entry.type === 'reasoning_item' && entry.backendIndex === -1))
    .map((entry) =>
      entry.type === 'thinking_item' && entry.status !== 'complete'
        ? { ...entry, status: 'complete' as const }
        : entry
    );
